
export default function CoreBenefitsSection() {
  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            仕上げボーリングで効く"3つの核心"
          </h2>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* プロセス図 */}
          <div className="lg:col-span-1">
            <div className="space-y-6">
              <div className="bg-yellow-100 p-4 rounded-lg text-center">
                <i className="ri-settings-3-line text-3xl text-yellow-600 mb-2"></i>
                <div className="font-bold text-gray-900">段取り</div>
              </div>
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
              </div>
              <div className="bg-yellow-100 p-4 rounded-lg text-center">
                <i className="ri-focus-3-line text-3xl text-yellow-600 mb-2"></i>
                <div className="font-bold text-gray-900">プリセット</div>
              </div>
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
              </div>
              <div className="bg-yellow-100 p-4 rounded-lg text-center">
                <i className="ri-send-plane-line text-3xl text-yellow-600 mb-2"></i>
                <div className="font-bold text-gray-900">NC転送</div>
              </div>
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
              </div>
              <div className="bg-green-100 p-4 rounded-lg text-center">
                <i className="ri-check-line text-3xl text-green-600 mb-2"></i>
                <div className="font-bold text-gray-900">一発良品</div>
              </div>
            </div>
          </div>
          
          {/* 3つの核心 */}
          <div className="lg:col-span-3">
            <div className="space-y-8">
              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <span className="text-black font-bold text-lg">1</span>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">一発良品化</h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      事前測定で"狙い寸法"を確定 → 追い込み工程を原則廃止
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <span className="text-black font-bold text-lg">2</span>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">標準化と平準化</h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      作業者差を吸収 → 誰でも5分でボーリングバー段取り（実績）
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <span className="text-black font-bold text-lg">3</span>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">データ化でエラー撲滅</h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      NC自動転送→転記ミス0、多国籍・多人数でも安定運用
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
